module.exports = __webpack_public_path__ + "static/media/fbd_white.f9556c16.png";